// import React from "react";
import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import sha256 from "crypto-js/sha256";
// import { Link } from "react-router-dom";
// import alasql from "alasql";

import { useDispatch, useSelector } from "react-redux";
// import { update } from "../../redux/portfolioSlice";
import { update } from "../../rtk/features/portfolio/portfolioSlice";

import "./portfolio.css";
import { FilterBlockchain } from "../../components/filters/Blockchain";
import { MostAdvancedTable } from "../../components/reactTable/MostAdvancedTable";
import Pie from "../../components/pie/Pie";
import { tblColumns } from "../../components/reactTable/columns";
import SetTitle from "../../components/setTitle/SetTitle";
// import { pyApiPortfolioUrl } from "../../config";
// import { productRows } from "../../dummyData";
// import Chart from '../../components/chart/Chart'
// import { ColumnFilter } from "../../components/reactTable/ColumnFilter";
// import { SelectColumnFilter } from "../../components/filters/SelectColumnFilter";
import LinearDeterminate from "../../components/mui/progress/LinearDeterminate";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import imgAvalanche from "../../img/avalanche.svg";
import imgBsc from "../../img/bsc.svg";
import imgCelo from "../../img/celo.svg";
import imgPolygon from "../../img/polygon.svg";

export default function Portfolio(props) {
  SetTitle("Portfolio @ DefiWatch.biz");

  const [isLoading, setIsLoading] = useState(true);
  const [tblData, setTblData] = useState([]);
  const [filteredTblData, setFilteredTblData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [tab, setTab] = useState(
    JSON.parse(localStorage.getItem("portfolioTab")) ?? 0
  );
  const [showZeroBal, setShowZeroBal] = useState(
    JSON.parse(localStorage.getItem("portfolioShowZeroBal")) ?? false
  );
  const [vaultType, setVaultType] = useState(
    JSON.parse(localStorage.getItem("portfolioVaultType")) ?? "All"
  );
  const handleVaultTypeChange = (event) => {
    setVaultType(event.target.value);
  };

  const portfolio = useSelector((state) => state.portfolio);

  const dispatch = useDispatch();
  const handleUpdate = (e) => {
    e.preventDefault();
    dispatch(update({ tblData }));
    // dispatch(update({ filteredTblData }));
  };

  // local storage ____________________________________________________________________
  useEffect(() => {
    localStorage.setItem("portfolioTab", JSON.stringify(tab));
  }, [tab]);

  useEffect(() => {
    localStorage.setItem("portfolioShowZeroBal", JSON.stringify(showZeroBal));
  }, [showZeroBal]);

  useEffect(() => {
    localStorage.setItem("portfolioVaultType", JSON.stringify(vaultType));
  }, [vaultType]);
  // /local storage

  useEffect(() => {
    console.log("pieData", pieData);
  }, [pieData]);

  useEffect(() => {
    if (!props.userAuthWallet) {
      // console.log('Please connect wallet!')
      return;
    }

    //pyApiPortfolioUrl
    const apiUrl = "/portfolio";
    const url =
      process.env.REACT_APP_CRUD_SRV +
      apiUrl +
      "?auth=" +
      props.userAuthWallet +
      "&cs=" +
      sha256(
        apiUrl + props.userAuthWallet + process.env.REACT_APP_SECRET
      ).toString();
    if (process.env.REACT_APP_CLG_AXIOS_URLS == 1) console.log(url);
    axios.get(url).then((res) => {
      //setTblData(res.data);
      if (res.data.status != 200) {
        console.log("Error recieving portfolio data!");
        return;
      }

      const tblDataShort = res.data.response.map((item) => {
        //console.log("Test item =", item);

        item.Wallet =
          item.Wallet.substr(0, 4) +
          "..." +
          item.Wallet.substr(item.Wallet.length - 4);

        if (item.LpTokensUsd)
          item.LpTokensUsd = item.LpTokensUsd.replace(/,/g, ", ");

        if (item.RewardTokensUsd)
          item.RewardTokensUsd = item.RewardTokensUsd.replace(/,/g, ", ");

        return item;
      });
      setTblData(tblDataShort);
      //dispatch(update({ tblData }));

      const usdtDebt = res.data.response.find((x) => x.id == 8);
      //console.log('usdtDebt=',usdtDebt);

      const wallets = [
        ...new Set(res.data.response.map((item) => item.Wallet)),
      ];
      //console.log(wallets);
      /*const curWallet = 0;

      let pieDataShort = res.data.response.map((item) => {
        //if (item.Wallet == "0xAf...135F" && item.TotalUsd > 0) {
        if (item.Wallet == wallets[curWallet] && item.TotalUsd > 0) {
          //AaveUsdt-AaveUsdtDebt
          if (item.id == 7)
            return {
              value: item.TotalUsd + usdtDebt.TotalUsd,
              name:
                item.Blockchain +
                "_" +
                item.Platform +
                "_" +
                item.Vault +
                "-UsdtDebt",
            };
          else
            return {
              value: item.TotalUsd,
              name:
                //item.Wallet.substr(item.Wallet.length - 4) +
                //"_" +
                item.Blockchain + "_" + item.Platform + "_" + item.Vault,
            };
        }
      });
      setPieData({ wallet: wallets[curWallet], data: pieDataShort });*/

      const pieDelimiter = " ";

      let pies = [];
      wallets.forEach((wallet) => {
        let pieDataShort = res.data.response
          .filter((row) => row.Wallet == wallet && row.TotalUsd > 0.001)
          .map((item) => {
            // if (item.Wallet == wallet && item.TotalUsd > 0.001) {
            // console.log("Pie Tot$", item);

            //AaveUsdt-AaveUsdtDebt
            if (item.id == 7)
              return {
                value: item.TotalUsd + usdtDebt.TotalUsd,
                name:
                  // item.Blockchain +
                  // "_" +
                  // item.Platform +
                  // "_" +
                  // item.Vault +
                  // "-UsdtDebt",
                  item.Vault +
                  "-UsdtDebt" +
                  pieDelimiter +
                  item.Platform +
                  pieDelimiter +
                  +item.Blockchain,
                vaultType: item.auto,
              };
            else
              return {
                value: item.TotalUsd,
                name:
                  //item.Wallet.substr(item.Wallet.length - 4) +
                  //"_" +
                  // item.Blockchain + "_" + item.Platform + "_" + item.Vault,
                  item.Vault +
                  pieDelimiter +
                  item.Platform +
                  pieDelimiter +
                  item.Blockchain,
                vaultType: item.auto,
              };
            // }
          });
        pies.push({ wallet: wallet, data: pieDataShort });
      });
      setPieData(pies);

      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    if (tblData.length > 0) {
      const tmpTblData = showZeroBal
        ? [...tblData]
        : tblData.filter(
            (row) =>
              row.Balance != 0 ||
              row.TotalUsd != 0 ||
              (row.Reward !== null && row.Reward != 0)
          );
      // console.log("filteredTblData", tmpTblData, tblData);
      setFilteredTblData(tmpTblData);
    }
  }, [tblData, showZeroBal]);

  // if (!props.userAuthWallet)
  //   return <h2>Please connect your wallet to Metamask</h2>;
  // else if (isLoading) {
  //   return <h2>Loading...</h2>;
  // }
  // if (isLoading) {
  //   return <LinearDeterminate />;
  // }

  const AddId = (data) => {
    let i = 0;
    let r = data.map((row) => {
      return { id: i++, ...row };
    });
    return r;
  };

  const handleDelete = (id) => {
    //setData(data.filter((item) => item.id !== id));
  };

  /*const SelectColumnFilter = ({
    column: { filterValue, setFilter, preFilteredRows, id },
  }) => {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
      const options = new Set();
      preFilteredRows.forEach((row) => {
        options.add(row.values[id]);
      });
      return [...options.values()];
    }, [id, preFilteredRows]);
  
    // Render a multi-select box
    return (
      <select
        value={filterValue}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}
      >
        <option value="">All</option>
        {options.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  }*/

  // This is a custom filter UI that uses a
  // slider to set the filter value between a column's
  // min and max values
  function SliderColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
  }) {
    // Calculate the min and max
    // using the preFilteredRows

    const [min, max] = useMemo(() => {
      let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
      let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
      preFilteredRows.forEach((row) => {
        min = Math.min(row.values[id], min);
        max = Math.max(row.values[id], max);
      });
      return [min, max];
    }, [id, preFilteredRows]);

    return (
      <>
        <input
          type="range"
          min={min}
          max={max}
          value={filterValue || min}
          onChange={(e) => {
            setFilter(parseInt(e.target.value, 10));
          }}
        />
        <button onClick={() => setFilter(undefined)}>Off</button>
      </>
    );
  }

  /*const rColumns = [
    { field: "id", headerName: "Asset Id", width: 60 },
    { field: "Datetime", headerName: "Datetime", width: 180 },
    { field: "Wallet", headerName: "Wallet", width: 120 },
    {
      field: "Blockchain",
      headerName: "Blockchain",
      width: 180,
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      field: "Platform",
      headerName: "Platform",
    },
    {
      field: "Vault",
      headerName: "Vault",
      width: 140,
    },
    { field: "Balance", headerName: "Balance", width: 200 },
    { field: "LpTokensUsd", headerName: "LpTokensUsd", width: 200 },
    { field: "BalanceUsd", headerName: "BalanceUsd", width: 200 },
    {
      field: "Reward",
      headerName: "Rewards",
      width: 200,
      Filter: SliderColumnFilter,
      filter: "equals",
    },
    { field: "RewardToken", headerName: "Rewards Tokens", width: 200 },
    { field: "RewardTokensUsd", headerName: "RewardTokensUsd", width: 200 },
    { field: "RewardUsd", headerName: "RewardUsd", width: 200 },
    { field: "TotalUsd", headerName: "TotalUsd", width: 200 },
  ];*/

  const colorScale = (v) => {
    return v >= 50
      ? "colorScale50"
      : v >= 30
      ? "colorScale30"
      : v >= 20
      ? "colorScale20"
      : v >= 10
      ? "colorScale10"
      : v >= 5
      ? "colorScale5"
      : v == 0
      ? "colorScale0"
      : "colorScaleDefault";
  };

  var getName = (x) => {
    return x[0]["Dt"];
  };
  var getVal1 = (x) => {
    return typeof x[1] === "undefined" ? 0 : x[1]["Balance"];
  };
  var getVal2 = (x) => {
    return typeof x[2] === "undefined" ? 0 : x[2]["Balance"];
  };
  var getVal3 = (x) => {
    return typeof x[3] === "undefined" ? 0 : x[3]["Balance"];
  };
  var getVal4 = (x) => {
    return typeof x[4] === "undefined" ? 0 : x[4]["Balance"];
  };
  var getVal5 = (x) => {
    return typeof x[5] === "undefined" ? 0 : x[5]["Balance"];
  };
  var getVal6 = (x) => {
    return typeof x[6] === "undefined" ? 0 : x[6]["Balance"];
  };
  var getVal7 = (x) => {
    return typeof x[7] === "undefined" ? 0 : x[7]["Balance"];
  };
  var getVal8 = (x) => {
    return typeof x[8] === "undefined" ? 0 : x[8]["Balance"];
  };
  var getVal9 = (x) => {
    return typeof x[9] === "undefined" ? 0 : x[9]["Balance"];
  };
  var getVal10 = (x) => {
    return typeof x[10] === "undefined" ? 0 : x[10]["Balance"];
  };
  //console.log('gD:', graphData)

  const supportedTokens = [
    {
      image: "",
      name: "All",
    },
    {
      image: imgAvalanche,
      name: "Avax",
    },
    {
      image: imgBsc,
      name: "BSC",
    },
    {
      image: imgCelo,
      name: "Celo",
    },
    {
      image: "",
      name: "Cronos",
    },
    {
      image: "",
      name: "Ethereum",
    },
    {
      image: "",
      name: "Fantom",
    },
    {
      image: imgPolygon,
      name: "Polygon",
    },
  ];

  //console.log("tblData =", tblData);

  return (
    <div className="page portfolioPage">
      <div className="topSubMenu">
        <h1>Portfolio</h1>

        <Tabs
          value={tab}
          onChange={(evt, val) => {
            // console.log(val);
            return setTab(val);
          }}
          className="portfolioTabs"
        >
          <Tab label="Summary" />
          <Tab label="Details" />
          {/* <Tab label="Disabled" disabled /> */}
        </Tabs>

        <FormControl
          variant="standard"
          sx={{ m: 1, minWidth: 120 }}
          className="vaultStatusMenu extraSmall"
        >
          <InputLabel id="select-standard-label">Vault Type</InputLabel>
          <Select
            labelId="select-standard-label"
            id="select-standard"
            value={vaultType}
            onChange={handleVaultTypeChange}
            label="Status"
          >
            <MenuItem value="All">
              {/* <em>All</em> */}
              All
            </MenuItem>
            <MenuItem value="Auto">Auto</MenuItem>
            <MenuItem value="Manual">Manual</MenuItem>
          </Select>
        </FormControl>
      </div>

      {isLoading ? (
        <LinearDeterminate />
      ) : (
        <>
          {/*<Pie pieTitle={pieData.wallet} pieData={pieData.data} />*/}
          {tab === 0 && (
            <>
              {/* <h2>Summary *</h2> */}
              {/* <p>
                <small>
                  * only vaults with the Total $ &gt; 0.001 are shown
                </small>
              </p> */}
              <div className="Pies">
                {pieData.map((pie) => {
                  return (
                    <Pie
                      key={pie.wallet}
                      pieTitle={pie.wallet}
                      pieData={
                        // pie.data
                        vaultType == "All"
                          ? pie.data
                          : pie.data.filter((row) => row.vaultType == vaultType)
                      }
                    />
                  );
                })}
              </div>
              <p className="portfolioNotes">
                * only vaults with the Total $ &gt; 0.001 are shown
              </p>
            </>
          )}

          {tab === 1 && (
            <>
              {/* <h2 className="detailedPortfolio">Details</h2> */}
              <div className="topSubMenuBlock">
                <FilterBlockchain supportedTokens={supportedTokens} />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showZeroBal}
                      onChange={(evt, val) => setShowZeroBal(val)}
                      name="showZeroBal"
                    />
                  }
                  label="Show zero balances"
                  // labelPlacement="top"
                />
              </div>

              <MostAdvancedTable
                propData={filteredTblData}
                tblColumns={tblColumns}
              />

              <button className="updateButton" onClick={handleUpdate}>
                Update
              </button>
            </>
          )}

          {/*<br />
      <DataGrid
        rows={tblData}
        columns={rColumns}
        pageSize={15}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
      />*/}
        </>
      )}
    </div>
  );
}
